export default {
  'aiAgentTeam.title': 'Manage AI Agent Teams',
};
